import { Stack, Typography } from "@mui/material";
import { RolePermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { useStores } from "../../../mobx-stores/_root-store";
import { PageContainer } from "../../../share-components/templates/page/page-container";
import { PageContentContainer } from "../../../share-components/templates/page/page-content-container";
import { PageHeaderContainer } from "../../../share-components/templates/page/page-header-container";
import { AddRole } from "./add-role/add-role";
import { AssignPermission } from "./assign-permissions/assign-permissions";
import { EditRole } from "./edit-role/edit-role";
import { RoleList } from "./role-list/role-list";

export const RoleAndPermission = observer(() => {
  const {
    rolePermissionManagement: {
      openNew,
      openEdit,
      pagination,
      getRoles,
      openAssignPermissions,
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getRoles({ ...pagination.toBaseRequestModel() });
  }, [getRoles, pagination]);
  return (
    <PageContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageFilterContainer direction={"row"}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          flexWrap={"wrap"}
          rowGap={"10px"}
        >
          <XSearchTextField
            sx={{
              minWidth: "300px",
            }}
            value={pagination.filter}
            onChange={(e) =>
              pagination.setProp("filter", e.currentTarget.value)
            }
          ></XSearchTextField>

          <SearchButton asyncAction={onSearch}></SearchButton>
        </Stack>
      </PageFilterContainer>
      <PageContentContainer>
        <RoleList></RoleList>
      </PageContentContainer>

      <>
        {openNew && <AddRole></AddRole>}
        {openEdit && <EditRole />}
        {openAssignPermissions && <AssignPermission />}
      </>
    </PageContainer>
  );
});

const Header = observer(() => {
  const {
    rolePermissionManagement: { setProp },
  } = useStores();
  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Vai trò và phân quyền</Typography>
      </Stack>
      <Stack>
        <AddButton
          accessPermission={[RolePermission.Create]}
          onClick={() => setProp("openNew", true)}
        >
          Thêm vai trò
        </AddButton>
      </Stack>
    </>
  );
});
